import { Outlet, ScrollRestoration } from 'react-router-dom';
import { AuthBridge } from '@/auth/AuthBridge';

/**
 * Top-level layout rendered under all routes. Replaces the body of the old
 * Remix `root.tsx`. Document-level concerns (`<head>`, fonts, viewport) now
 * live in index.html; global providers live in App.tsx.
 */
export function RootLayout() {
    return (
        <>
            <AuthBridge />
            <Outlet />
            <ScrollRestoration />
        </>
    );
}
